
import ClickOutside from 'vue-click-outside';
import { StyleColorSchemeType, StyleSizeType, StylePositionType } from '../../styles/enums';
import { StyleFillType } from '../input/enums';
import { DropdownInputChange, DropdownProperty } from './enums';
import Input from '../input';
import { IconType } from '../icon/enums';
import StyleClassNamesBuilder from '../../styles/helpers/StyleClassNamesBuilder';
import DropdownProps from './mixins/DropdownProps';

export default {
  name: 'Dropdown',
  components: {
    Input,
  },
  directives: {
    ClickOutside,
  },
  mixins: [DropdownProps],
  data() {
    return {
      isOpened: false,
      StyleSizeType,
      StyleColorSchemeType,
      StylePositionType,
      DropdownProperty,
    };
  },
  computed: {
    wrapperClassNames() {
      return new StyleClassNamesBuilder('dropdown')
        .addConditionClassName('outlined', this[DropdownProperty.FillType] === StyleFillType.Outlined)
        .addClassName(this.className)
        .build();
    },
    menuWrapperClass() {
      return new StyleClassNamesBuilder('dropdown-menu')
        .addClassName(this[DropdownProperty.MenuClassName])
        .build();
    },
    appendInputIcon() {
      return this.isOpened ? IconType.ChevronUp : IconType.ChevronDown;
    },
    menuStyles() {
      const dropdownInputRef = this.$refs['dropdown-input'];

      if (!dropdownInputRef) {
        return {};
      }

      const { offsetWidth } = dropdownInputRef;

      return {
        width: `${offsetWidth}px`,
      };
    },
  },
  methods: {
    handleInputClick() {
      if (!this[DropdownProperty.Disabled]) {
        this.isOpened = !this.isOpened;
        this.$emit('inputClick', this.isOpened);
      }
    },
    handleInputChange(value) {
      this.$emit(DropdownInputChange.Change, value);
    },
    handleOutsideClick() {
      if (this.isOpened) {
        this.$emit(DropdownInputChange.Close, this[DropdownProperty.Value]);
      }

      this.isOpened = false;
    },
    handleDropdownMenuClick(event) {
      event.stopPropagation();

      if (this[DropdownProperty.HideOnContentClick]) {
        this.isOpened = false;
      }
    },
  },
};
